import React from 'react';

import ErrorMessageConstants from 'app/shared/constants/ErrorMessageConstants';
import appLogger from 'app/shared/loggers/appLogger';

export default (response, brand, user) => {
    const {
        duplicateExists,
        duplicateSyndicatedUrl,
        forSaleExists,
        forSaleUrlOnZillow,
        restrictedFromNyc,
        willAppear,
        isTopListingDuplicateAccountListing,
    } = response;
    const learnMoreElement = (
        <a
            href="https://help.zillowrentalmanager.com/hc/en-us/articles/217482388-Why-didn-t-my-listing-go-live-"
            target="_blank"
            rel="noopener noreferrer"
        >
            Learn more
        </a>
    );
    const propertyAlreadyPostedElements = href => ([
        'This property is ',
        <a href={href} target="_blank" rel="noopener noreferrer">
            already posted
        </a>,
    ]);
    const logErrorAndReturn = (message) => {
        appLogger.logError({
            message,
            context: 'handleLocationRestrictionResponse',
            user,
        });
        return message;
    };

    if (restrictedFromNyc) {
        const message = ErrorMessageConstants.LOCATION_RESTRICTION.NYC;
        return logErrorAndReturn(message);
    }

    if (!willAppear) {
        const message = ErrorMessageConstants.LOCATION_RESTRICTION.MF_REQUIRED(brand);
        return logErrorAndReturn(message);
    }

    if (forSaleExists && forSaleUrlOnZillow) {
        const message = [
            ...propertyAlreadyPostedElements(forSaleUrlOnZillow),
            ' for sale. Listings cannot be listed for rent and for sale at the same time. ',
            learnMoreElement,
        ];
        return logErrorAndReturn(message);
    }

    if (forSaleExists && !forSaleUrlOnZillow) {
        const message = [
            // eslint-disable-next-line max-len
            'This property was already posted for sale elsewhere. Listings cannot be listed for rent and for sale at the same time. ',
            learnMoreElement,
        ];
        return logErrorAndReturn(message);
    }

    if (duplicateExists) {
        // If the top listing is the duplicate account listing, don't display duplicate listing restriction messages.
        if (isTopListingDuplicateAccountListing) {
            return null;
        }
        if (duplicateSyndicatedUrl) {
            const message = [
                ...propertyAlreadyPostedElements(duplicateSyndicatedUrl),
                ' from another source. ',
                learnMoreElement,
            ];
            return logErrorAndReturn(message);
        }
        const message = ErrorMessageConstants.LOCATION_RESTRICTION.DUPLICATE.MESSAGE;
        return logErrorAndReturn(message);
    }

    return null;
};
